import { LoaderCircle } from 'lucide-react';
import { Button } from '@/components/ui/button';

export function SubmitButton({ isSubmitting, label, submittingLabel, className }) {
  return (
    <Button type="submit" size="lg" disabled={isSubmitting} className={className}>
      {isSubmitting ? <LoaderCircle aria-hidden="true" className="size-5 motion-safe:animate-spin" /> : null}
      {isSubmitting ? submittingLabel : label}
    </Button>
  );
}